@if (isMobile) {
  <div class="pt-20">
    <app-sidebar-category-link [restrictUser]="restrictUser" [isSidebar]="false"></app-sidebar-category-link>
  </div>
}

@defer (when isConfigLoaded) {
  <app-vpn-message></app-vpn-message>
  <app-main-banner-container></app-main-banner-container>
  @if (isMobile) {
    <app-active-filters></app-active-filters>
  } @else {
    <app-categories></app-categories>
  }
  <app-more-games
    [category]="'hot'"
    [newGames]="newGames"
    [hotGames]="hotGames"
    [isSimilar]="false"
    [isMainPage]="true"></app-more-games>
} @error {}
@if (isConfigLoaded) {
  @defer (on viewport; prefetch on idle) {
    <app-carousel-banner
      type="main"
      slug="carousel-banner"
      uniqueId="1"
      primaryColor="bg-carouselCurrent"
      secondaryColor="bg-carouselCurrent"
      longWidth="w-14"
      shortWidth="w-3.5"></app-carousel-banner>
  } @placeholder {
    <div class="w-full h-[24.5rem]"></div>
  } @error {}
  @defer (on viewport; prefetch on idle) {
    <app-more-games
      [category]="'popular'"
      [newGames]="newGames"
      [hotGames]="hotGames"
      [isSimilar]="false"
      [isMainPage]="true"></app-more-games>
  } @placeholder {
    <div class="w-full h-[37.5rem]"></div>
  } @error {}
  @defer (on viewport; prefetch on idle) {
    <app-promotions [isPromotionPage]="false"></app-promotions>
  } @placeholder {
    <div class="w-full h-[28.625rem]"></div>
  } @error {}
  @defer (on viewport; prefetch on idle) {
    <app-lucky-players [restrictUser]="restrictUser"></app-lucky-players>
  } @placeholder {
    <div class="w-full h-[25.125rem]"></div>
  } @error {}
}
